import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    copyright: '© {year} All rights reserved',
    policy: 'Privacy Policy',
    tos: 'Terms of Service',
    docs: 'Docs',
    faq: 'FAQ',
  },
};
